import { Product } from '../../../catalog/products/product';
import { SchemeBase } from '../../checkout/cart/scheme.class';
import { ServiceBase } from './service';

export abstract class EquipementBase extends Product {
    public updateSchemeOnRemove(scheme: SchemeBase): SchemeBase {
        const products: Product[] = scheme.getProductsByType(ServiceBase);
        if (scheme.products.length - products.length === 0) {
            products.forEach((product: Product) => {
                scheme.remove(product.uniqueId);
            });
        }
        return scheme;
    }

    protected updatePrice(): void {
        super.updatePrice();
        this.applyPromo();
    }

    protected applyPromo(): boolean {
        return true;
    }
}
